export default "__VITE_ASSET__c77a3cbc__"